<dialog id="{{ modalId }}" class="modal modal-middle">
  <div class="modal-box w-full max-w-md p-9 rounded-2xl text-center">
    <div class="text-4xl mb-3">🎉</div>
    <h2 class="text-2xl font-bold text-primary mb-3">You're all set!</h2>
    <p class="text-sm text-base-content/70 leading-relaxed mb-7">
      You can replay this tour anytime from the <strong>(?)</strong> button in the top-right corner. Good luck with your
      genomics work!
    </p>
    <div class="flex justify-center gap-3">
      <button type="button" class="btn btn-primary px-7" (click)="onDone()">Get started</button>
      <button type="button" class="btn btn-outline px-5" (click)="onReplay()">Replay tour</button>
    </div>
  </div>
</dialog>
